import vSelect from 'vue-select'
// import 'vue-select/dist/vue-select.css';

import vDatepicker from '../components/vue-datepicker';
import vModal from '../components/vue-modal';

Vue.component('vue-datepicker', vDatepicker);
Vue.component('vue-modal', vModal);
Vue.component('v-select', vSelect);